"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRace = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Creates a new race.
 *
 * ## Usage
 * ```ts
 * const race: Omit<Race, "_id"> = {
 * 	name: "The best race ever!",
 *  instructions: "You will need a controller, so prepare.",
 *  objectives: "Get 100 starts in the shortest time possible.",
 *  type: RaceType.TIME,
 *  startDate: new Date(),
 *  endDate: new Date(16893846783483),
 *  downloadLink: "https://masochist.me",
 *  downloadGrace: "30",
 *  uploadGrace: "30",
 *  owner: "738927465878329",
 *  season: "5eda7778c87dd9a7",
 *  icon: "http://http.cat/404.jpg",
 * };
 *
 * const {
 * 	acknowledged,
 *  insertedId,
 * } = await sdk.createRace({ race });
 * ```
 *
 * @param params.race - Object with the data of the new race.
 */
const createRace = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { race } = params;
    const url = `${BASE_URL}/races`;
    const raceResponse = yield axios_1.default.post(url, race, { validateStatus: () => true });
    const { status, data } = raceResponse;
    if (status !== 201)
        throw new Error(data.error);
    return data;
});
exports.createRace = createRace;
